import { createFileRoute } from '@tanstack/react-router';
import { parse, object, string, optional } from 'valibot';

import { getPatientQueryKey } from '@/features/patients/hooks/usePatient';
import { medplum } from '@/config/medplum';

export const Route = createFileRoute('/(authenticated)/patients/$patientId')({
	validateSearch: (search) => {
		return parse(
			object({
				program_id: optional(string()),
			}),
			search,
		);
	},
	loader: async ({ params, context }) => {
		// Prefetch patient data using Medplum
		await context.queryClient.prefetchQuery({
			queryKey: getPatientQueryKey(params.patientId),
			queryFn: () => medplum.readResource('Patient', params.patientId),
		});
	},
});
